import { render, staticRenderFns } from "./mobile-host.vue?vue&type=template&id=2237d4b0&"
import script from "./mobile-host.vue?vue&type=script&lang=ts&"
export * from "./mobile-host.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports